import './assets/css/main.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "vue-loading-overlay/dist/css/index.css";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import Vuetify from '@/config/Vuetify';
import 'vuetify/dist/vuetify.css';

library.add(fas);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import {i18n} from "@/config/i18n.js";

import $ from 'jquery'

window.$ = window.jQuery = $


const app = createApp(App)
app.component('VueDatePicker', VueDatePicker);
app.use(router)

app.use(store)

app.use(Vuetify)

app.component('icon', FontAwesomeIcon);

app.use(Toast);

app.use(i18n);

app.config.globalProperties.$app_image = process.env.VUE_APP_ASSETS_IMAGE

app.config.globalProperties.$app_video = process.env.VUE_APP_ASSETS_VIDEO

app.mount('#app');
